import styled from 'styled-components';

const PaneGuide = styled.div`
  position: absolute;
  right: -32px;
  top: 32px;  
`

export { PaneGuide }
